import React from "react";
import { Sparkles, ShoppingBag, ChevronRight } from "lucide-react";

const abs = (u) => !u ? null : (/^https?:\/\//.test(u) ? u : `${process.env.REACT_APP_BACKEND_URL}${u.startsWith("/") ? u : `/${u}`}`);
const eur = (v) => `€ ${Number(v || 0).toFixed(2)}`;

export const DailyProductCard = ({ product, onOrder, onOpen }) => {
  if (!product) return null;
  const img = abs(product.image_url);
  const hasDiscount = product.discount_pct > 0;
  return (
    <div
      data-testid="daily-product-card"
      className="relative overflow-hidden rounded-2xl border-2 border-amber-400/70 card-elev shadow-[0_12px_40px_-12px_rgba(245,158,11,0.45)]"
    >
      <div className="flex gap-3 p-3">
        <button
          type="button"
          onClick={() => onOpen?.(product)}
          data-testid="daily-product-image"
          className="relative shrink-0 h-24 w-24 rounded-xl overflow-hidden bg-amber-50 border border-amber-200 active:scale-[0.97] transition-transform"
        >
          {img ? (
            <img src={img} alt={product.name} className="h-full w-full object-cover" />
          ) : (
            <div className="h-full w-full flex items-center justify-center text-amber-500"><Sparkles className="h-8 w-8" /></div>
          )}
          {hasDiscount && (
            <span data-testid="daily-product-discount" className="absolute top-1 left-1 px-1.5 py-0.5 rounded-md bg-red-500 text-white text-[10px] font-bold shadow">
              -{product.discount_pct}%
            </span>
          )}
        </button>
        <div className="flex-1 min-w-0 flex flex-col">
          <div className="flex items-center gap-1.5 text-[10px] uppercase tracking-widest text-amber-600 font-bold">
            <Sparkles className="h-3 w-3 animate-pulse" /> {product.label}
          </div>
          <button type="button" onClick={() => onOpen?.(product)} className="text-left mt-1" data-testid="daily-product-name">
            <div className="font-heading font-bold text-base leading-tight truncate">{product.name}</div>
            {product.category && <div className="text-[11px] text-zinc-500">{product.category}</div>}
          </button>
          <div className="mt-auto flex items-end justify-between gap-2 pt-2">
            <div className="leading-none">
              {hasDiscount && <div className="text-[11px] text-zinc-500 line-through">{eur(product.price)}</div>}
              <div className="text-lg font-black text-amber-600" data-testid="daily-product-price">{eur(product.price_today)}</div>
            </div>
            {onOrder && (
              <button
                type="button"
                onClick={() => onOrder(product)}
                data-testid="daily-product-order-btn"
                className="inline-flex items-center gap-1.5 h-9 px-3.5 rounded-full bg-amber-400 text-zinc-950 text-xs font-bold hover:bg-amber-300 active:scale-95 transition-all"
              >
                <ShoppingBag className="h-3.5 w-3.5" /> Ordina ora <ChevronRight className="h-3.5 w-3.5" />
              </button>
            )}
          </div>
        </div>
      </div>
      <div className="px-3 pb-2 text-[10px] text-zinc-500">Offerta valida solo oggi · domani cambia</div>
    </div>
  );
};

export default DailyProductCard;
